<template>
  <div id="intro">
    <div id="bg_header" class="title-header">
      <div class="mask">
        <br />
        <h1>Guru do Cartola 2024</h1>
        <br />
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p>
            Após os nossos assinantes CONQUISTAREM o 1º lugar em <b>5.299</b> ligas anuais ou mata-mata em <b>2023</b>, só temos um desafio: aumentar esse número em 2024.<br /><br />
            Foram <b>5.299</b> ligas em primeiro lugar! Isso sem contar as ligas não oficiais ou ligas por rodada!<br /><br />
            Esse resultado excepcional nos motiva a continuar dedicando cada minuto da nossa atenção ao melhor plano de assinantes do Brasil. <br /><br />
            E, depois de um ano tão vitorioso, todas as nossas energias estão em superar os números em 2024.<br /><br />
            Já estamos preparando conteúdos exclusivos para manter os nossos assinantes no topo nessa próxima temporada.<br /><br />
            Quer saber mais? <b>Cadastre o seu e-mail aqui embaixo</b>:<br /><br />
          </p>
          <br />
        </div>
        <form
          id="CTA_1"
          class="form-inline custom_CTA"
          style="z-index:1;margin-bottom:-45px"
        >
          <label class="sr-only" for="name_1">Nome</label>
          <input
            type="text"
            class="form-control mb-2 mr-sm-2"
            id="name_1"
            placeholder="Seu Nome"
            v-model="user_nome"
          />
          <label class="sr-only" for="email_1">Seu e-mail</label>
          <div class="input-group mb-2 mr-sm-2">
            <input
              type="email"
              class="form-control"
              id="email_1"
              placeholder="Seu E-mail"
              v-model="user_email"
            />
          </div>
          <button
            id="submit_1"
            type="button"
            class="styled_button btn btn-warning mb-2"
            style="float:right;"
             v-on:click="saveUserAtQueue()"
          >
            Quero fazer parte do Guru em 2024!
          </button>
        </form>
      </div>
    </div>
    <div id="bg_header">
      <div class="mask">
        <br />
        <h1>Retrospectiva 2023</h1>
        <br />
      </div>
    </div>
    <section id="section_0">
      <div class="container">
        <div class="row">
          <div class="col-lg-2 col-md-2 col-sm-12"></div>
          <div class="col-lg-8 col-md-8 col-sm-12">
            <!--@TODO 
            <img
              src="https://images2.imgbox.com/f0/59/DOjYbQOS_o.png"
              class="img-fluid"
              alt="Guru do Cartola - Retrospectiva 2023 - Prêmios"
            />
            -->
            <!--@TODO 
            <img
              src="https://images2.imgbox.com/10/75/gZ6LJMEA_o.png"
              class="img-fluid"
              alt="Guru do Cartola - Retrospectiva 2023 - Resultados"
            />
            -->
          </div>
          <div class="col-lg-2 col-md-2 col-sm-12"></div>
          <form
            id="CTA_2"
            class="form-inline"
            style="z-index:1;margin-bottom:10px"
          >
            <label class="sr-only" for="name_2">Nome</label>
            <input
              type="text"
              class="form-control mb-2 mr-sm-2"
              id="name_2"
              placeholder="Seu Nome"
              v-model="user_nome"
            />
            <label class="sr-only" for="email_2">Seu e-mail</label>
            <div class="input-group mb-2 mr-sm-2">
              <input
                type="email"
                class="form-control"
                id="email_2"
                placeholder="Seu E-mail"
                v-model="user_email"
              />
            </div>
            <button
              id="submit_2"
              type="button"
              class="styled_button btn btn-warning mb-2"
              style="float:right;"
               v-on:click="saveUserAtQueue()"
            >
              Quero participar do Guru em 2024!
            </button>
          </form>
        </div>
      </div>
    </section>

    <section id="section_1">
      <div class="container">
        <h3 class="text-center styled_title"><span>Sobre o Guru...</span></h3>
        <div class="row">
          <div class="col-lg-9 col-md-9 col-sm-12">

            <p style="text-align:justify;">
            O Guru do Cartola surgiu em 2017 como o primeiro site e aplicativo a mostrar em tempo real a pontuação mínima para valorizar e também a valorização em tempo real dos jogadores do Cartola. 
            </p>
            <p style="text-align:justify;">Até hoje é a grande referência em valorização em tempo real e pontuação mínima para valorizar, sendo o único que mostra os valores exatos.
            Em 2018 criamos o nosso plano de assinantes e já foi um sucesso! Coroado com o título de Campeão do Guru do Cartola na Liga Oficial do Cartola entre os Influenciadores. 
            </p>
            <p style="text-align:justify;">
            No ano seguinte, em 2019, mais uma inovação importantíssima estava por vir: o Guru do Cartola se tornou o único site (além do site oficial do Cartola) onde os cartoleiros conseguem escalar o seu time.
            </p>
            <p style="text-align:justify;">
            Além disso, no site o cartoleiro conta com várias informações exclusivas: mapa de calor dos jogadores, pontuações cedidas pelos adversários, médias por mando de campo e várias outras estatísticas.
            </p>
            <p style="text-align:justify;">
            Aliadas aos grupos de Whatapp com conteúdo exclusivo, as estatísticas e times exclusivos foram fundamentais para o Guru se consolidar como o plano de dicas que forma mais campeões todos os anos.
            </p>
            <p style="text-align:justify;">
            Somente em 2022 foram 4.300 ligas oficiais conquistadas. Sem contar as ligas mensais ou por rodada.
            </p>
            <p style="text-align:justify;">
            Agora em 2023 o Time Guru recebe o reforço do Meio Kilo, o melhor jogador do Rei do Pitaco. Ele já soma mais de R$ 300.000,00 faturados no game. 
            </p>
            <p style="text-align:justify;">
            Espero que você esteja conosco em nossa jornada para 2023.
            </p>

            <p style="text-align:justify;">
              Grande abraço,
              <br /><br />
              Luís - Fundador do Guru do Cartola
            </p>
            <br />
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12" id="desktop_extension">
            <br /><br /><br />
            <!-- @TODO 
            <img
              src="https://images2.imgbox.com/06/db/lWFBYICV_o.jpg"
              class="img-thumbnail"
              alt="guru do cartola em 2023"
            />
            -->
            <br /><br />
          </div>
        </div>
      </div>
    </section>

    <section id="section_2">
      <div class="container">
        <hr />
        <h3 class="text-center styled_title">Premiações</h3>
        <div class="row">
          <div
            id="carousel"
            class="carousel slide"
            data-ride="carousel"
            style="margin: 0 auto;"
            data-interval="2250"
          >
            <div class="carousel-inner">
              <div
                class="carousel-item"
                :class="{ active: i === 1 }"
                v-for="i in items.length"
                :key="i"
              >
                <img
                  class="d-block w-100 img-fluid"
                  :src="items[i-1].imagem"
                  alt="Guru do Cartola - Premiações"
                />
              </div>
            </div>
            <a
              class="carousel-control-prev"
              href="#carousel"
              role="button"
              data-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next"
              href="#carousel"
              role="button"
              data-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-10 col-md-12 col-lg-12">
          <a
            data-target="#carousel"
            v-for="i in items.length"
            :key="i"
            :data-slide-to="i - 1"
            href="#"
          >
            <img
              :src=" items[i-1].thumbnail "
              class="img gallery_image"
              alt="Guru do Cartola - Premiações"
            />
          </a>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      // items: ['11_rodada_Almir.jpeg', '10_rodada_Felipe_Gomes.jpeg', '9_rodada_Alysson_Barreto.jpg', '7_rodada_Leonardo_Soares.jpg', '6_rodada_Julio_Fondora.jpeg', '5_rodada_Sergio_Fonseca.jpeg', '4_rodada_Joao_Wancura.jpeg', '3_rodada_Luis_Augusto.jpg', '1_rodada_Celio_Martins.jpeg', '36_Suelen_Ramos.jpeg', '34_Thiago_Venancio.jpeg', '33_Felipe_Gomes.jpeg', '32_Wilson_Filho.jpeg', '31_Cristian_Collares.jpg', '30_Fernando_Magalhaes.jpeg', '29_Gothardo_Santos.jpg', '28_rodada_Junior_Kamenach.jpeg', '27_Martins.jpeg', '26_rodada_Diego_Ferber.jpg', '25_rodada_Breno_Moreira.jpg', '23_rodada_Mizael_Marcos.jpg', '22_rodada_Carlos_Alexandre.jpg', '21_rodada_Vinicius_Gomes.jpg', '20_rodada_Julio_Fondora.jpeg', '19_rodada_Tiago_Souza.jpeg', '16.jpeg', '17_rodada_Flavio_Rodrigues.jpeg', '14_rodada_Michel_Queiroz.jpg', '13_rodada_Vinicius_Gomes.jpg', '12_rodada_Andre_Vilela.jpeg', '8_rodada_Everton_Demo.jpeg', '7_rodada_Will_Ambrosio.jpeg', '6_rodada_Nilo_Otavio.jpg', '5_rodada_Joao_Vitor_Batista.jpg', '4_rodada_Renato_Barbosa.jpg', '3_rodada_Byankye_Pereira.jpeg', '2_rodada_Tiago_Oliveira.jpeg', '1_rodada_Byankye_Pereira.jpeg', 'Tiago_Macedo_liga_rodada_9_1_lugar.jpeg', 'MM_15_Joao_Lima.jpeg', 'MM_Bruno_Milano.jpg', 'MM_Caio_Brilha.jpg', 'MM_Denis.jpg', 'MM_Leonardo_Saraiva.jpg', 'MM_Vitor_Souza.jpg', 'MM_Jhonata_Noronha.jpg', 'MM_Guilherme_Amaro.jpg', 'MM_Ph.jpeg', 'MM_Andrade.jpeg', 'MM_Junior_Souza.jpeg', 'Joao_Libertadores.jpeg', 'MM_15_Joao_Lima.jpeg', 'MM_Leandro_Alonso.jpeg', 'MM_Jorge_Borges.jpg', 'ps4_Joao_Lima.jpeg', '4.jpeg', '1.jpeg'],
      items: [],
      //JSON.parse('[{"id":1,"thumbnail":"1_t.jpeg","imagem":"1.jpeg","time":"Urubu Fanático","nome":"Anderson Lima","rodada":0,"ano":2018},{"id":2,"thumbnail":"6_rodada_Julio_Fondora_t.jpg","imagem":"6_rodada_Julio_Fondora.jpeg","time":"Fenomenólogo F.C.","nome":"Julio Fondora","rodada":6,"ano":2020},{"id":3,"thumbnail":"4_rodada_Joao_Wancura_t.jpg","imagem":"4_rodada_Joao_Wancura.jpeg","time":"Deportivo FerroCarril","nome":"João Wancura","rodada":4,"ano":2020},{"id":4,"thumbnail":"3_rodada_Luis_Augusto_t.jpg","imagem":"3_rodada_Luis_Augusto.jpg","time":"GuazzelliSC","nome":"Luis Augusto","rodada":3,"ano":2020},{"id":5,"thumbnail":"4_t.jpeg","imagem":"4.jpeg","time":null,"nome":"Claudemar Carvalho","rodada":38,"ano":2018},{"id":6,"thumbnail":"1_rodada_Celio_Martins_t.jpg","imagem":"1_rodada_Celio_Martins.jpeg","time":"FLA SESI RJ","nome":"Célio Martins","rodada":1,"ano":2020},{"id":7,"thumbnail":"5_rodada_Sergio_Fonseca_t.jpg","imagem":"5_rodada_Sergio_Fonseca.jpeg","time":"GurusFonseca","nome":"Sérgio Fonseca","rodada":5,"ano":2020},{"id":8,"thumbnail":"7_rodada_Leonardo_Soares_t.jpg","imagem":"7_rodada_Leonardo_Soares.jpg","time":"Voa Canoas FC","nome":"Leonardo Soares","rodada":7,"ano":2020},{"id":9,"thumbnail":"10_rodada_Felipe_Gomes_t.jpg","imagem":"10_rodada_Felipe_Gomes.jpeg","time":"ArFeKe FC","nome":"Felipe Gomes","rodada":10,"ano":2020},{"id":10,"thumbnail":"9_rodada _Alysson_Barreto_t.jpg","imagem":"9_rodada_Alysson_Barreto.jpg","time":"Rubroneros FC","nome":"Alysson Barreto","rodada":9,"ano":2020},{"id":11,"thumbnail":"11_rodada_Almir_t.jpg","imagem":"11_rodada_Almir.jpeg","time":"Chumbrega Baby","nome":"Almir","rodada":11,"ano":2020},{"id":13,"thumbnail":"17_rodada_Flavio_Rodrigues_t.jpeg","imagem":"17_rodada_Flavio_Rodrigues.jpeg","time":"NAY ESPORTE CLUB","nome":"Flavio Rodrigues","rodada":17,"ano":2019},{"id":14,"thumbnail":"20_rodada_Julio_Fondora_t.jpeg","imagem":"20_rodada_Julio_Fondora.jpeg","time":"Leão Banguela","nome":"Julio Fondora","rodada":20,"ano":2019},{"id":15,"thumbnail":"21_rodada_Vinicius_Gomes_t.jpg","imagem":"21_rodada_Vinicius_Gomes.jpg","time":"CorinthianoSofredor","nome":"Vinicius Gomes","rodada":21,"ano":2019},{"id":16,"thumbnail":"22_rodada_Carlos_Alexandre_t.jpg","imagem":"22_rodada_Carlos_Alexandre.jpg","time":"Desespero E.C.","nome":"Carlos Alexandre","rodada":22,"ano":2019},{"id":17,"thumbnail":"23_rodada_Mizael_Marcos_t.jpg","imagem":"23_rodada_Mizael_Marcos.jpg","time":"Bate Chave Sinop F.C","nome":"Mizael Marcos","rodada":23,"ano":2019},{"id":18,"thumbnail":"25_rodada_Breno_Moreira_t.jpg","imagem":"25_rodada_Breno_Moreira.jpg","time":"Basquete F.C.","nome":"Breno Moreira","rodada":25,"ano":2019},{"id":19,"thumbnail":"26_rodada_Diego_Ferber_t.jpg","imagem":"26_rodada_Diego_Ferber.jpg","time":"FOX SOCCER FUN","nome":"Diego Ferber","rodada":26,"ano":2019},{"id":20,"thumbnail":"MM_15_Joao_Lima_t.jpeg","imagem":"MM_15_Joao_Lima.jpeg","time":"Índio fc 10","nome":"João Lima","rodada":0,"ano":2019},{"id":21,"thumbnail":"Tiago_Macedo_liga_rodada_9_1_lugar_t.jpeg","imagem":"Tiago_Macedo_liga_rodada_9_1_lugar.jpeg","time":"Tjmm futebol vlube","nome":"Tiago Macedo","rodada":0,"ano":2019},{"id":22,"thumbnail":"27_Martins_t.jpg","imagem":"27_Martins.jpeg","time":"MELHOR SR","nome":"Celio Martins","rodada":27,"ano":2019},{"id":23,"thumbnail":"29_Gothardo_Santos_t.jpg","imagem":"29_Gothardo_Santos.jpg","time":"Goth EC","nome":"Gothardo Santos","rodada":29,"ano":2019},{"id":24,"thumbnail":"30_Fernando_Magalhaes_t.jpg","imagem":"30_Fernando_Magalhaes.jpeg","time":"Magalhães champions","nome":"Fernando Magalhães","rodada":30,"ano":2019},{"id":25,"thumbnail":"31_Cristian_Collares_t.jpg","imagem":"31_Cristian_Collares.jpg","time":"Rei de Copas FBPA 1903","nome":"Cristian Collares","rodada":31,"ano":2019},{"id":26,"thumbnail":"32_Wilson_Filho_t.jpg","imagem":"32_Wilson_Filho.jpeg","time":"MYLLANEZZA EC","nome":"Wilson Filho","rodada":32,"ano":2019},{"id":27,"thumbnail":"33_Felipe_Gomes_t.jpg","imagem":"33_Felipe_Gomes.jpeg","time":"ArFeKe FC","nome":"Felipe Gomes","rodada":33,"ano":2019},{"id":28,"thumbnail":"34_Thiago_Venancio_t.jpg","imagem":"34_Thiago_Venancio.jpeg","time":"Blancos Madrid","nome":"Thiago Venancio","rodada":34,"ano":2019},{"id":29,"thumbnail":"36_Suelen_Ramos_t.jpg","imagem":"36_Suelen_Ramos.jpeg","time":"Brazuca Champions","nome":"Suelen Ramos","rodada":36,"ano":2019},{"id":30,"thumbnail":"MM_Bruno_Milano_t.jpg","imagem":"MM_Bruno_Milano.jpg","time":"Milano Bruno FC","nome":"Bruno Milano","rodada":0,"ano":2019},{"id":31,"thumbnail":"MM_Denis_t.jpg","imagem":"MM_Denis.jpg","time":"Sharkman futebol clu","nome":"Denis Augusto","rodada":0,"ano":2019},{"id":32,"thumbnail":"MM_Leonardo_Saraiva_t.jpg","imagem":"MM_Leonardo_Saraiva.jpg","time":"Verdão do Cerrado 2019","nome":"Leonardo Saraiva","rodada":0,"ano":2019},{"id":33,"thumbnail":"MM_Vitor_Souza_t.jpg","imagem":"MM_Vitor_Souza.jpg","time":"BoonfimFC","nome":"Vitor Souza","rodada":0,"ano":2019},{"id":34,"thumbnail":"MM_Caio_Brilha_t.jpg","imagem":"MM_Caio_Brilha.jpg","time":"CGCB FC","nome":"Caio Brilha","rodada":0,"ano":2019},{"id":35,"thumbnail":"MM_Jhonata_Noronha_t.jpg","imagem":"MM_Jhonata_Noronha.jpg","time":"Petelas CRF","nome":"Jhonata Noronha","rodada":0,"ano":2019},{"id":36,"thumbnail":"MM_Guilherme_Amaro_t.jpg","imagem":"MM_Guilherme_Amaro.jpg","time":"Catatinhas Fc","nome":"Guilherme Amaro","rodada":0,"ano":2019},{"id":37,"thumbnail":"MM_Ph_t.jpg","imagem":"MM_Ph.jpeg","time":"PHI.EUA","nome":"Phillipe Laurence","rodada":0,"ano":2019},{"id":38,"thumbnail":"MM_Andrade_t.jpg","imagem":"MM_Andrade.jpeg","time":"Papai da duda","nome":"Andrade","rodada":0,"ano":2019},{"id":39,"thumbnail":"MM_Junior_Souza_t.jpg","imagem":"MM_Junior_Souza.jpeg","time":"atletica sport club","nome":"Junior Souza","rodada":0,"ano":2019},{"id":40,"thumbnail":"MM_15_Joao_Lima_t.jpeg","imagem":"MM_15_Joao_Lima.jpeg","time":"Índio fc 10","nome":"João Lima","rodada":0,"ano":2019},{"id":41,"thumbnail":"MM_Leandro_Alonso_t.jpg","imagem":"MM_Leandro_Alonso.jpeg","time":"Alonso United FC","nome":"Leandro Alonso","rodada":0,"ano":2019},{"id":42,"thumbnail":"MM_Jorge_Borges_t.jpg","imagem":"MM_Jorge_Borges.jpg","time":"Farcelona02","nome":"Jorge Borges","rodada":0,"ano":2019},{"id":43,"thumbnail":"ps4_Joao_Lima_t.jpg","imagem":"ps4_Joao_Lima.jpeg","time":"Índio fc 10","nome":"João Lima","rodada":0,"ano":2019},{"id":44,"thumbnail":"Joao_Libertadores_t.jpg","imagem":"Joao_Libertadores.jpeg","time":"WineGrandTime","nome":"João Júnior","rodada":0,"ano":2019},{"id":45,"thumbnail":"7_Will_Ambrosio_t.jpg","imagem":"7_rodada_Will_Ambrosio.jpeg","time":"Will Harper FC","nome":"Will Ambrosio","rodada":7,"ano":2019},{"id":46,"thumbnail":"8_rodada_Everton_Demo_t.jpg","imagem":"8_rodada_Everton_Demo.jpeg","time":"Alemão Futebol Clube","nome":"Éverton Demo","rodada":8,"ano":2019},{"id":47,"thumbnail":"19_rodada_Tiago_Souza_t.jpg","imagem":"19_rodada_Tiago_Souza.jpeg","time":"Tiago souza F.C 2019","nome":"Tiago Souza","rodada":19,"ano":2019},{"id":48,"thumbnail":"28_rodada_Junior_Kamenach_t.jpg","imagem":"28_rodada_Junior_Kamenach.jpeg","time":"Caiçara Futebol e Cachaça","nome":"Junior Kamenach","rodada":28,"ano":2019},{"id":56,"thumbnail":"13_rodada_Vinicius_Gomes_t.jpg","imagem":"13_rodada_Vinicius_Gomes.jpg","time":"CorinthianoSofredor","nome":"Vinicius Gomes","rodada":13,"ano":2019},{"id":57,"thumbnail":"14_rodada_Michel_Queiroz_t.jpg","imagem":"14_rodada_Michel_Queiroz.jpg","time":"Kaneladas Sport Club","nome":"Michel Queiroz","rodada":14,"ano":2019},{"id":58,"thumbnail":"16_t.jpeg","imagem":"16.jpeg","time":"Xibórnia Sport Clube","nome":"Tiago Oliveira","rodada":18,"ano":2019},{"id":60,"thumbnail":"12_rodada_Andre_Vilela_t.jpeg","imagem":"12_rodada_Andre_Vilela.jpeg","time":"AVG Rubro Negro","nome":"Andre Vilela","rodada":12,"ano":2019},{"id":80,"thumbnail":"1_rodada_Byankye_Pereira_t.jpeg","imagem":"1_rodada_Byankye_Pereira.jpeg","time":"S.E Pereira","nome":"Byankye Pereira","rodada":1,"ano":2019},{"id":81,"thumbnail":"2_rodada_Tiago_Oliveira_t.jpeg","imagem":"2_rodada_Tiago_Oliveira.jpeg","time":"Xibórnia Sport Clube","nome":"Tiago Oliveira","rodada":2,"ano":2019},{"id":82,"thumbnail":"3_rodada_Byankye_Pereira_t.jpeg","imagem":"3_rodada_Byankye_Pereira.jpeg","time":"S.E Pereira","nome":"Byankye Pereira","rodada":3,"ano":2019},{"id":83,"thumbnail":"4_rodada_Renato_Barbosa_t.jpg","imagem":"4_rodada_Renato_Barbosa.jpg","time":"Piuziense","nome":"Renato Barbosa","rodada":4,"ano":2019},{"id":84,"thumbnail":"5_rodada_Joao_Vitor_Batista_t.jpg","imagem":"5_rodada_Joao_Vitor_Batista.jpg","time":"Jota Jota Batista FC","nome":"João Vitor Batista","rodada":5,"ano":2019},{"id":85,"thumbnail":"6_rodada_Nilo_Otavio_t.jpg","imagem":"6_rodada_Nilo_Otavio.jpg","time":"Rubro Firenze","nome":"Nilo Otavio","rodada":6,"ano":2019}]'),
      last_post_wp: null,
      user_nome: '',
      user_email: '',

      //Verificação mobile
      mobileAt: 1000, //Mobile a partir de qual width?
      mobile: false, //Status inicial do mobile
      col: null
    };
  },
  created() {
    //Verificação mobile
    window.innerWidth < this.mobileAt
      ? (this.mobile = true)
      : (this.mobile = false);

    var vm = this;

    //Recarregue o twitter depois de meio segundo da criação da página
    setTimeout(function() {
      vm.reload_twitter_iframe();
    }, 500);

    //Carregue o último post no wordpress
    // $.ajax({
    //   type: "GET",
    //   url: "https://gurudocartola.com/last_post_wp.php",
    //   success: function(result) {
    //     vm.last_post_wp = JSON.parse(result);
    //   },
    //   error: function(error) {
    //     console.log(error);
    //   }
    // });
    this.$http
    .get('https://gurudocartola.com/last_post_wp.php')
    .then(response => {
      vm.last_post_wp = JSON.parse(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });

    this.$http
    .get(this.$API+'fotos-premiacao/')
    .then(response => {
      vm.items = response.data;
      vm.items.sort(function (a, b) {
            if (a.ano > b.ano) {  return -1; } 
            else if (a.ano < b.ano) { return 1; } 
            else if (a.rodada > b.rodada) { return -1; } 
            else if (a.rodada < b.rodada) { return 1; } 
            else { return 0; } // ano e rodada sao iguais
        });
    })
    .catch(function (error) {
      console.log(error);
    });
  },
  mounted() {
    /* Image Desactivation */
    if ($(window).width() <= 825) {
      $("#desktop_extension").remove();
    }
    /*Carousel Activation*/
    let aux = 0;
    $(window).scroll(function() {
      let pageTop = document.documentElement.scrollTop;
      let carouselTop = Math.round($("#carousel").position().top);
      let diff = carouselTop - pageTop;
      if (diff <= 350 && aux == 0) {
        $("#carousel").carousel(0);
        aux = 1;
      }
    });
  },
  methods: {
    //Recarregue o iframe do twitter
    reload_twitter_iframe() {
      $("#twitter-wjs").remove();
      $("#iframe_twitter").html("");

      setTimeout(function() {
        window.twttr = (function(d, s, id) {
          var e = d.getElementsByTagName(s);
          e[0].parentNode.removeChild(e[0]);
          var t,
            js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s);
          js.id = id;
          js.src = "https://platform.twitter.com/widgets.js";
          fjs.parentNode.insertBefore(js, fjs);

          return (
            window.twttr ||
            (t = {
              _e: [],
              ready: function(f) {
                t._e.push(f);
              }
            })
          );
        })(document, "script", "twitter-wjs");
      }, 100);

      $("#iframe_twitter").html(
        '<a class="twitter-timeline" href="https://twitter.com/Gurudocartola_?ref_src=twsrc%5Etfw"></a>'
      );
    },
    //Remove as tags html de uma string "s"
    clean_string_from_html_tags(s) {
      return s.replace(/<\/?[^>]+(>|$)/g, "");
    },
    saveUserAtQueue(){
         const call_url = this.$API+'queue/add/';
          var myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          var raw = JSON.stringify({"nome":this.user_nome, "email":this.user_email});
          var requestOptions = {
               method: 'POST',
               headers: myHeaders,
               body: raw,
               redirect: 'follow'
          };
          
          if (this.user_nome === null || this.user_nome === '') {
              // eslint-disable-next-line
              Swal.fire('Ops!','Você precisa informar seu nome','warning');  
          } else if (!this.validateEmail(this.user_email)) {
              // eslint-disable-next-line  
              Swal.fire('Ops!','O e-mail não foi informado ou não parece válido','warning');  
          } else {
              fetch(call_url, requestOptions).then(response => response.text());
              // eslint-disable-next-line
              Swal.fire('Obrigado '+this.user_nome+'!','Entraremos em contato em breve','success');  
          }
    },
    validateEmail(mail) {
          // eslint-disable-next-line
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
               return (true)
          }
          return (false)
     }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

/*Fonts*/
@import url("https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i|Ubuntu:300,300i,400,400i,500,500i,700,700i");

body {
  font-family: "Ubuntu", sans-serif;
  background-color: #f5f5f5 !important;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23e3e3e3' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
}

/*Background header with image and title*/
.title-header {
  margin-top: 67px;
  // border-bottom: 3px solid orange;
}
#btn-yt:hover {
     color: white;
}

#intro {
  background-color: #f5f5f5 !important;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23e3e3e3' fill-opacity='0.4' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
}
#bg_header {
  //@TODO background: url("https://images2.imgbox.com/0d/f6/1127pgyl_o.png");
  background-color: $verde;
}
#bg_header .mask {
  background-color: rgba(0, 0, 0, 0.45);
}
#bg_header .mask h1 {
  font-family: "Montserrat", sans-serif;
  text-align: center;
  text-transform: uppercase;
  padding: 35px;
  font-weight: 200;
  letter-spacing: 5px;
  color: white;
  text-shadow: 0px 4px 2px rgba(0, 0, 0, 0.95);
}

.styled_title {
  font-family: "Montserrat", sans-serif;
  text-align: center;
  text-transform: uppercase;
  padding: 35px;
  font-weight: 200;
  letter-spacing: 5px;
}

/*main div with background white*/
#tool {
  background-color: white;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.3);
}
#tool h3,
p {
  padding: 10px 20px;
}
#tool h3 {
  font-weight: 400;
}
#tool button {
  border: 0px;
  border-radius: 0px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 3px;
}

#section_0 {
  background-color: $laranja; //#f29c00;
  color: white;
  // background-image: linear-gradient(#f29c00 40%, #f26500);
  // background-image: linear-gradient(to right, #f29c00 20%, #F16800, #f29c00 20%);
  background-image: linear-gradient(to right, #f29c00 ,#F16800 10%, #F16800 90%  , #f29c00);
  // background-image: linear-gradient( 135deg, #92FFC0 10%, #002661 100%);
}
#section_0:before {
  content: "";
  position: absolute;
  border-top: 50px solid $laranja;
  // width: 100%;
  transform: rotate(-1deg);
  transform-origin: 0% 0%;
}

#section_0,
#section_1,
#section_2 {
  margin-top: -20px;
}
#section_1 {
  background-color: #0aa75e;
  color: white;
  background-image: linear-gradient(#0aa75e 60%, #077140);
}
#section_1:before {
  content: "";
  position: absolute;
  border-top: 50px solid #0aa75e;
  // width: 100%;
  transform: rotate(1deg);
  transform-origin: 0% 0%;
  margin-top: -30px;
}
#section_1 span {
  border-bottom: 2px solid #2d2d2d;
}
#section_0 form,
#section_1 form,
.custom_CTA {
  padding: 20px;
  margin: 0 auto;
  margin-bottom: -25px;
  z-index: 1;
  -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
}
#section_0 form,
.custom_CTA {
  // background-color: #0b0b0b;
  // background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12' viewBox='0 0 20 12'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='charlie-brown' fill='%23855200' fill-opacity='0.4'%3E%3Cpath d='M9.8 12L0 2.2V.8l10 10 10-10v1.4L10.2 12h-.4zm-4 0L0 6.2V4.8L7.2 12H5.8zm8.4 0L20 6.2V4.8L12.8 12h1.4zM9.8 0l.2.2.2-.2h-.4zm-4 0L10 4.2 14.2 0h-1.4L10 2.8 7.2 0H5.8z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  // background-image: linear-gradient(to right, #f29c00, #F16800 10%, #F16800 90%, #f29c00);
  background-image: linear-gradient( 135deg, #01734d 10%, #0AA75E 100%);
}
#section_1 form {
  background-color: #0b0b0b;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='12' viewBox='0 0 20 12'%3E%3Cg fill-rule='evenodd'%3E%3Cg id='charlie-brown' fill='%23006723' fill-opacity='0.4'%3E%3Cpath d='M9.8 12L0 2.2V.8l10 10 10-10v1.4L10.2 12h-.4zm-4 0L0 6.2V4.8L7.2 12H5.8zm8.4 0L20 6.2V4.8L12.8 12h1.4zM9.8 0l.2.2.2-.2h-.4zm-4 0L10 4.2 14.2 0h-1.4L10 2.8 7.2 0H5.8z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
#section_1 form button {
  border-radius: 5px;
  color: #023c21;
  font-weight: bolder;
  letter-spacing: 1px;
  background-color: #0aa75e;
  border-bottom: 2px solid #023c21;
  white-space: normal;
}
#section_0 form button,
.custom_CTA button {
  border-radius: 5px;
  color: #753403;
  font-weight: bolder;
  letter-spacing: 1px;
  background-color: #f29c00;
  border-bottom: 2px solid #a74903;
  white-space: normal;
}
#section_2 {
  background-color: #2d2d2d;
  color: white;
  background-image: linear-gradient(#2d2d2d 60%, #151515);
}
#section_2:before {
  content: "";
  position: absolute;
  border-top: 50px solid #2d2d2d;
  // width: 100%;
  transform: rotate(-1deg);
  transform-origin: 0% 0%;
}
#section_2 h5 {
  font-family: "Montserrat", sans-serif;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  color: white;
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.95);
}
.carousel-control-next-icon,
.carousel-control-prev-icon {
  border-bottom: none !important;
}
.carousel-control-next-icon {
  margin-right: -150px;
}
.carousel-control-prev-icon {
  margin-left: -150px;
}
.carousel-inner {
  -webkit-box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.75);
}
#section_2 .carousel-item img {
  width: 400px !important;
  height: 400px !important;
}
#section_2 span {
  border-bottom: 2px solid #0aa75e;
}
.styled_button {
  font-family: "Montserrat", sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 3px;
  border-radius: 0px;
}
.gallery_image {
  width: 50px !important;
  height: 50px !important;
  margin: 15px 10px !important;
  opacity: 0.5;
  transition: 0.2s;
  border: 1px solid white;
}
.gallery_image:hover {
  opacity: 1;
  cursor: pointer;
}

.carousel-item > img {
  object-fit: cover;
}

#social {
  background-color: orange;
}
#social i {
  margin: 0 auto;
  color: #543701;
  font-size: 25px;
  background-color: #d08702;
  padding: 15px;
}

#social i:hover {
  color: orange;
  background-color: #543701;
}

@media only screen and (max-width: 500px) {
  #bg_header .mask h1 {
    font-size: 30px !important;
  }
  #section_0 form {
    width: 80%;
  }
  #section_1 form {
    width: 80%;
  }
  #section_2 .carousel-item img {
    width: 175px !important;
    height: 175px !important;
  }
  .gallery_image {
    width: 25px !important;
    height: 25px !important;
    margin: 10px 5px !important;
    opacity: 0.5;
    transition: 0.2s;
    border: 1px solid white;
  }
  .carousel-control-prev-icon {
    margin-left: -100px;
  }
  .carousel-control-next-icon {
    margin-right: -100px;
  }
  .carousel {
    left: -15px;
  }
}
</style>
